const getRuntimeAppConfig = () => window.__APP_CONFIG__ ?? {};

export default getRuntimeAppConfig;
